<template>
    <div>
        <div class="print-container">
            <el-button ref="printBtn" type="primary" v-print="printObj">打印</el-button>
            <div class="print" id="print">
                <h2 class="print-title">客户订单</h2>
                <div class="print-msg">
                    <div class="msg-item">
                        <div class="msg-label">客户编码：</div>
                        <div class="msg-value">{{printData.clientCode||''}}</div>
                    </div>
                    <div class="msg-item">
                        <div class="msg-label">客户名称：</div>
                        <div class="msg-value">{{printData.clientName||''}}</div>
                    </div>
                    <div class="msg-item">
                        <div class="msg-label">经销商编码：</div>
                        <div class="msg-value">{{printData.customerCode||''}}</div>
                    </div>
                    <div class="msg-item">
                        <div class="msg-label">经销商名称：</div>
                        <div class="msg-value">{{printData.customerName||''}}</div>
                    </div>
                    <div class="msg-item">
                        <div class="msg-label">订单号：</div>
                        <div class="msg-value">{{printData.orderCode||''}}</div>
                    </div>
                    <div class="msg-item">
                        <div class="msg-label">客户电话：</div>
                        <div class="msg-value">{{printData.telephone||''}}</div>
                    </div>
                    <div class="msg-item">
                        <div class="msg-label">所属组织：</div>
                        <div class="msg-value">{{printData.orgName||''}}</div>
                    </div>
                    <div class="msg-item">
                        <div class="msg-label">开单日期：</div>
                        <div class="msg-value">{{printData.orderDateStr||''}}</div>
                    </div>
                    <div class="msg-item">
                        <div class="msg-label">发货日期：</div>
                        <div class="msg-value">{{printData.ext11Str||''}}</div>
                    </div>
                </div>
                <div class="table-container">
                    <table class="table" width="100%" border="1px solid #333333">
                        <tr>
                            <th v-for="(item, index) in columns" :key="index" :width="item.width">{{item.text}}</th>
                        </tr>
                        <tbody>
                            <tr v-for="(item, index) in tableList" :key="index">
                                <td v-for="(cItem, cIndex) in columns" :key="cIndex">
                                    <span v-if="cItem.field=='brandName'">恒大冰泉</span>
                                    <span v-else>{{item[cItem.field]}}</span>
                                </td>
                            </tr>
                            <tr>
                                <template v-for="(cItem, cIndex) in columns">
                                    <td :key="cIndex">
                                        <span v-if="cItem.field=='brandName'">小计</span>
                                        <span v-if="cItem.field=='quantity'">{{printData.totalQuantity}}</span>
                                        <span v-if="cItem.field=='terminalTotalAmount'">{{printData.totalRealAmount}}</span>
                                        <span v-if="cItem.field=='ext23'">{{printData.totalRealQuantity}}</span>
                                    </td>
                                </template>
                            </tr>
                            <tr>
                                <td :colspan="columns.length">备注：以上订单中本品产品单位默认为“自然箱”。若不使用自然单位的，请另行标注</td>
                            </tr>
                            <tr>
                                <td :rowspan="4">客户收货确认</td>
                                <td :colspan="5"></td>
                                <td :rowspan="4">客户订货确认</td>
                                <td :colspan="3" class="text-left">合计自然箱数：{{printData.totalRealQuantity}}</td>
                            </tr>
                            <tr>
                                <td :colspan="5">
                                    <span v-if="printData.userPhone">业代电话：{{printData.userPhone}}</span></td>
                                <td :colspan="3" :rowspan="2" class="text-left">
                                    <div>合计金额：{{printData.totalRealAmount}}元</div>
                                    <div>金额大写：{{printData.totalRealAmountStr}}</div>
                                </td>
                            </tr>
                            <tr>
                                <td :colspan="5">
                                    <span v-if="printData.fullName1">业务代表：{{printData.fullName1}}</span>
                                    <span class="paddingleft20" v-if="printData.fullName2">主管：{{printData.fullName2}}</span>
                                </td>
                            </tr>
                            <tr>
                                <td :colspan="5">请客户收到如上产品后，在第二联上亲笔签字确认！请签字确定</td>
                                <td :colspan="3"></td>
                            </tr>
                            <tr>
                                <td :colspan="columns.length">
                                    <div class="table-bottom">
                                        <div class="table-check-item">
                                            <span>手工订单与系统订单一致</span>
                                            <div class="table-square"></div>
                                        </div>
                                        <div class="table-line"></div>
                                        <div class="table-check-item">
                                            <span>实际送品项与系统一致</span>
                                            <div class="table-square"></div>
                                        </div>
                                        <div class="table-check-item paddingleft20">
                                            <span>准时送货</span>
                                            <div class="table-circle"></div>
                                        </div>
                                        <div class="table-check-item paddingleft20">
                                            <span>延期送货</span>
                                            <div class="table-circle"></div>
                                        </div>
                                        <div class="table-check-item paddingleft20">
                                            <span>未送达</span>
                                            <div class="table-circle"></div>
                                        </div>
                                        <div class="table-check-item paddingleft20">
                                            <span>无效订单</span>
                                            <div class="table-circle"></div>
                                        </div>
                                    </div>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
                <div class="print-desc">备注：恒大冰泉业代不得参与收款。本送货单只作送货和收货凭证，未作特别标注或未经送货与收货双方约定，不能作为欠条使用</div>
            </div>
        </div>
    </div>
</template>
<script>
import print from 'vue-print-nb'
export default {
    name:'print',
    props: {
        printConfig: {
            type: Object,
            default: ()=>{
                return {}
            }
        }
    },
    directives: {
        print
    },
    watch: {
        printConfig: {
            deep: true,
            immediate: true,
            handler(val){
                if(val && val.value){
                    this.printData = val.value || {}
                    this.tableList = this.printData.hdSfaVisitStepOrderItemDistributionRespVos || []
                    this.$nextTick(()=>{
                        this.$refs.printBtn.$el.click()
                    })
                }
            }
        }
    },
    data(){
        return {
            printData: {}, // 打印的数据
            columns: [
                { text: '品牌', field: 'brandName', width: '100px' },
                { text: '产品名称', field: 'productName', width: '140px' },
                { text: '产品编码', field: 'productCode', width: '100px' },
                { text: '数量', field: 'quantity', width: '60px' },
                { text: '单位', field: 'unitName', width: '60px' },
                { text: '本/赠', field: 'itmeType', width: '60px' },
                { text: '单价(元)', field: 'price', width: '100px' },
                { text: '金额(元)', field: 'terminalTotalAmount', width: '100px' },
                { text: '实发数', field: 'ext23', width: '60px' },
                { text: '备注', field: 'remarks', width: '100px' }
            ],
            tableList: [],
            printObj: {
                id: "print",
                popTitle: '',
                extraHead: '<meta http-equiv="Content-Language"content="zh-cn"/>'
            },
        }
    },
    methods: {
        // 金额小写转换为大写
        AmountLtoU(num) {
            if (isNaN(num)) return "";
            var strPrefix = "";
            if (num < 0) strPrefix = "(负)";
            num = Math.abs(num);
            if (num >= 1000000000000) return "无效数值！";
            var strOutput = "";
            var strUnit = '仟佰拾亿仟佰拾万仟佰拾元角分';
            var strCapDgt = '零壹贰叁肆伍陆柒捌玖';
            num += "00";
            var intPos = num.indexOf('.');
            if (intPos >= 0) {
                num = num.substring(0, intPos) + num.substr(intPos + 1, 2);
            }
            strUnit = strUnit.substr(strUnit.length - num.length);
            for (var i = 0; i < num.length; i++) {
                strOutput += strCapDgt.substr(num.substr(i, 1), 1) + strUnit.substr(i, 1);
            }
            return strPrefix + strOutput.replace(/零角零分$/, '整').replace(/零[仟佰拾]/g, '零').replace(/零{2,}/g, '零').replace(/零([亿|万])/g, '$1').replace(/零+元/, '园').replace(/亿零{0,3}万/, '亿').replace(/^元/, "零园");
        },
    }
}
</script>
<style lang="scss" scoped>
@page{
    size:  auto;   /* auto is the initial value */ 
    // size: landscape; /* 横向打印 */ 
    // size: portrait; /* 纵向打印 */ 
    margin: 3mm 0;  /* this affects the margin in the printer settings */  /*去除页眉页脚*/
}
.paddingleft20{
    padding-left: 20px;
}
.print-container{
    display: none;
}
.print{
    padding: 20px;
}
.print-title{
    text-align: center;
    padding-bottom: 20px;
}
.print-msg{
    display: flex;
    flex-wrap: wrap;
    align-items: stretch;
}
.msg-item{
    width: 50%;
    box-sizing: border-box;
    display: flex;
    padding: 6px;
}
.msg-label{
    width: 120px;
    text-align: right;
}
.table-container{
    padding-top: 20px;
}
.table{
    border-collapse: collapse;
    text-align: center;
}
.text-left{
    text-align: left;
}
.table th, .table td{
    padding: 4px;
    box-sizing: border-box;
}
.table-bottom{
    display: flex;
    align-items: center;
    justify-content: center;
}
.table-line{
    margin: 0 10px;
    height: 20px;
    width: 1px;
    border-left: 1px solid #606266;
    box-sizing: border-box;
}
.table-check-item{
    display: flex;
    align-items: center;
}
.table-square{
    width: 14px;
    height: 14px;
    border: 1px solid #333;
    box-sizing: border-box;
    margin-left: 4px;
}
.table-circle{
    width: 14px;
    height: 14px;
    border-radius: 50%;
    border: 1px solid #333;
    box-sizing: border-box;
    margin-left: 4px;
}
.print-desc{
    text-align: center;
    padding-top: 10px;
}
</style>